import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

export const useServiceList = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const serviceListRef = doc(db, 'service_list', 'main');

    // Set up real-time listener for service list
    const unsubscribe = onSnapshot(
      serviceListRef,
      (docSnapshot) => {
        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          let services = data.services || [];
          
          // Handle both old array format and new object format
          if (services.length > 0 && typeof services[0] === 'string') {
            // Old format - convert to new format
            services = services.map(serviceName => ({
              name: serviceName,
              description: '',
              icon: 'FaTools'
            }));
          }
          
          setServices(services);
        } else {
          // Document doesn't exist - fallback to empty array
          console.log('Service list document not found');
          setServices([]);
        }
        setLoading(false);
      },
      (err) => {
        console.error('Error listening to service list:', err);
        setError('Failed to load service list.');
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  // Convert services array to options format for dropdowns
  const getServiceOptions = () => {
    return services.map(service => ({
      value: service.name.toLowerCase().replace(/\s+/g, '-'), // Convert "Lawn Mowing" to "lawn-mowing"
      label: service.name
    }));
  };

  return {
    services,
    loading,
    error,
    getServiceOptions
  };
};